"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const CardCallout_1 = __importDefault(require("./CardCallout"));
const GiftcardBox = ({ posaGiftCardRedeemUrl, showDesc }) => {
    return (react_1.default.createElement(CardCallout_1.default, { boxClass: "giftcard", title: 'epic.code.redemption.posa.giftcard.title', desc: showDesc ? 'epic.code.redemption.posa.giftcard.desc' : '', redeemLink: posaGiftCardRedeemUrl, imgSrc: "https://cdn2.unrealengine.com/fn-giftcard-5dbdc8b86ecb.svg" }));
};
GiftcardBox.propTypes = {
    posaGiftCardRedeemUrl: prop_types_1.default.string,
    showDesc: prop_types_1.default.bool
};
exports.default = GiftcardBox;
//# sourceMappingURL=GiftcardBox.js.map